<div class="modal-header">
  <h3 class="modal-title">Firma de archivos</h3>
  <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body" style="max-height: 80vh; overflow-y: auto;">

  <!-- Formulario para agregar firmantes (se aplicarán a todos los documentos) -->
  <form #form="ngForm" (ngSubmit)="createFields(form)" novalidate class="fields-inputs">
    <div>
      <label>Rut (########-#) <span class="text-danger">*</span></label>
      <input class="form-control input-size" name="identification" ngModel required #identification="ngModel"
        placeholder="Ej: 30.686.957-8">
      @if (identification.invalid && identification.touched) {
        <div class="text-danger">
          El RUT es requerido
        </div>
      }
    </div>
    <div>
      <label>Nombres <span class="text-danger">*</span></label>
      <input class="form-control input-size" name="name" ngModel required #name="ngModel">
      @if (name.invalid && name.touched) {
        <div class="text-danger">
          El nombre es requerido
        </div>
      }
    </div>
    <div>
      <label>Apellidos <span class="text-danger">*</span></label>
      <input class="form-control input-size" name="lastname" ngModel required #lastname="ngModel">
      @if (lastname.invalid && lastname.touched) {
        <div class="text-danger">
          El apellido es requerido
        </div>
      }
    </div>
    <div>
      <label>Email <span class="text-danger">*</span> <span style="color: red; margin-left: 10px">{{validEmailFormat ? "Formato invalido" : ''}}</span></label>
      <input (blur)="validateEmailFormat(form.form.value.email)" class="form-control input-size" name="email"
        required ngModel #email="ngModel">
      @if (email.invalid && email.touched) {
        <div class="text-danger">
          El email es requerido
        </div>
      }
    </div>
    <div>
      <label>Teléfono </label>
      <input class="form-control input-size" name="phone" ngModel #phone="ngModel">
    </div>
    <button [disabled]="!form.form.valid || !validateEmail(form.form.value.email)"
      class="btn btn-outline-primary rounded-pill text-dark font-weight-bold mr-2" style="height: 40px"
      type="submit">
      Agregar
    </button>
  </form>

  <!-- Tabla de firmantes (se aplicarán a todos los documentos) -->
  @if (signingparties.length) {
    <table class="fields-table">
      <thead>
        <th>Rut</th>
        <th>Nombre</th>
        <th>Apellido</th>
        <th>Email</th>
        <th>Teléfono</th>
        <th></th>
      </thead>
      <tbody>
        @for (field of signingparties; track field; let i = $index) {
          <tr>
            <td>{{field.identification}}</td>
            <td>{{field.name}}</td>
            <td>{{field.lastname}}</td>
            <td>{{field.email}}</td>
            <td>{{field.phone}}</td>
            <td><button class="btn btn-outline-dark rounded-pill font-weight-bold" (click)="removeField(i)"><i
            class="fas fa-trash"></i> Eliminar</button></td>
          </tr>
        }
      </tbody>
    </table>
  }

  <!-- Tipo de firma global (si está habilitado) -->
  @if (showMultipleSignatureTypes) {
    <div class="form-group mt-3">
      <label>Tipo de Firma <span class="text-danger">*</span></label>
      <small class="form-text text-muted">
        Seleccione el tipo de firma electrónica que desea utilizar para todos los documentos
      </small>
      <select class="form-control" [(ngModel)]="signatureType" name="signatureType">
        <option value="fea">FEA - Firma Electrónica Avanzada</option>
        <option value="simple">Simple - Firma con correo electrónico</option>
        <option value="docusign">DocuSign</option>
      </select>
    </div>
  }

  <!-- Lista de documentos cargados, cada uno con su título -->
  @for (document of documents; track document; let docIndex = $index) {
    <div class="document-section mb-4 p-3 border rounded">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Documento {{docIndex + 1}}: {{document.file.name}}</h5>
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeDocument(docIndex)">
          <i class="fas fa-trash"></i> Eliminar documento
        </button>
      </div>
      <!-- Título del documento -->
      <div class="form-group">
        <label>Titulo <span class="text-danger">*</span></label>
        <small class="form-text text-muted">
          Ingrese un título descriptivo (evite caracteres especiales como: < > & " ')
        </small>
        <input class="form-control" [(ngModel)]="document.title" [name]="'title_' + docIndex" required>
      </div>
    </div>
  }

  <!-- Sección para cargar archivos -->
  <div class="mb-4 mt-4">
    <app-attachment-to-sign (sendingFiles)="retrieveFiles($event)" [accept]="'application/pdf'">
    </app-attachment-to-sign>
  </div>

  <!-- Mensajes de éxito/error -->
  @if (successMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}
          </ngb-alert>
        </div>
      </div>
    </div>
  }
  @if (errorMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }

  <!-- Botones de acción -->
  <div class="form-group mt-3">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold"
          style="width: 120px;" (click)="activeModal.close('Close click')">
          Cerrar
        </button>
        <button type="button"
          [disabled]="documents.length === 0 || signingparties.length === 0 || loading"
          class="btn btn-outline-primary rounded-pill text-dark font-weight-bold mr-2"
          style="width: 120px;"
          (click)="submitForm(null)">
          @if (loading) {
            <div>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Procesando...
            </div>
          }
          @if (!loading) {
            <span>
              Guardar
            </span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
